module.exports = __webpack_public_path__ + "files/14367343175bc65d6e20fd235c356db4.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-96x96.png
// module id = 754
// module chunks = 27